import axios from "axios";
export default {
    apiGetBalance: () => axios.get("/Billing/GetBalance"),
    apiGetRequestStatistics: () => axios.get("/Billing/GetRequestStatistics")
};
